import { FeatureNote } from './feature-note';
import { HelpDocument } from './help-document';
import { CommunicationTypeEnum } from './communication-type-enum';

export interface Communication {
  viewed?: boolean;
  communicationId: string;
  applicationId?: string;
  applicationName?: string;
  applicationIds?: string[];
  releaseVersionNumber: string;
  headerText: string;
  shortDescription: string;
  releaseOverview?: string;
  longContent?: string;
  displayDate: Date;
  expireDate?: Date;
  releaseDate?: Date;
  lastUpdated?: Date;
  updatedBy?: string;
  releaseType?: string;
  releaseTypeId: string;
  featureNotes: FeatureNote[];
  bPublished: boolean;
  bForcePopup: boolean;
  bShowAfterView: boolean;
  communicationTypeId?: CommunicationTypeEnum | number;
  documents: HelpDocument[];
  documentsLocation?: string;
  isReleaseNote?: boolean;
  previousReleaseNoteId?: string;
  previousReleaseVersionNumber?: string;
  nextReleaseNoteId?: string;
  nextReleaseVersionNumber?: string;
}

export type CommunicationTypeStringEnum =
  | 'all'
  | 'announcements'
  | 'releaseNotes';
